import { Link } from "react-router-dom";
import Logo from "../image/404.webp";

const PageNotFound = () => {
    return (
        <div className='width_container'>
            <div className="text-center">
                <img src={Logo} className="mx-auto" alt="404" />
                <h1 className="font-bold text-[25px] mt-7">Page Not Found</h1>
                <p className="mt-2 mb-8 text-gray-600">We can’t find the page you are looking for.</p>
                <Link to="/" className="bg-[--bgcolor] text-white font-medium py-[8px] px-[25px] rounded-[5px] hover:scale-105 hover:shadow-lg duration-300">Go to home</Link>
            </div>
        </div>
    )
}

export default PageNotFound